import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form'
import { renderCal, renderInput, renderCheckbox }from '../newcaso/Fields'

import _ from 'lodash'

import Odontograma from '../../common/Odontograma'
import OdontogramaIRP from '../../common/OdontogramaIRP'
import connect from "react-redux/es/connect/connect";

class ModelsStep2 extends Component{
    constructor(props){
        super(props);
        this.state = {
            attachments: [],
            irp: [],
            notes: {noteNum_0:"test deesde state"},
        }
    }
    componentDidMount(){
        if(!_.isEmpty(this.props.stepsGroup)){
            let attaches = this.props.stepsGroup[1];
            attaches = _.groupBy(attaches, 'step');
            let irp = this.props.stepsGroup[0];
            irp = _.groupBy(irp, 'step');
            this.setState({
                attachments: attaches,
                irp: irp
            })
        }
    }
    renderSelect(field){
        if(_.isEmpty(this.props.casos.data)){
            return(<div className="form-group">loading</div>);
        }
        var options = this.props.casos.data.map((caso) => {
            return(
                <option key={caso.id} value={caso.id}>{caso.id}</option>
            )
        });
        return(
            <div className="form-group">
                <label>{field.label} test</label>
                <select
                    className="form-control"
                    {...field.input}
                >
                    {options}
                </select>
            </div>
        )
    }
    selectPiece(id, type, pieces, pieceClicked, piece){
        let newState = this.state;
        let totalCaso = this.props.caso && this.props.caso.modelos && this.props.caso.modelos.length && this.props.caso.modelos.length/2;
        let totalUopload = this.props.files.order.length / 2;
        let total = totalCaso+totalUopload;
        if(type === "attachments"){
            newState[type][id] = pieces;
            for (let i= Number(id)+1; i < total; i++){
                let newPieces = null;
                if(!newState[type]){
                    newState[type] = [];
                }
                if(newState[type][i] && newState[type][i].length > 0){
                    newPieces = [...newState[type][i].filter(
                        item => item.value != piece
                    ), ...pieceClicked]
                }else{
                    newPieces = pieceClicked;
                }
                newState[type][i] = newPieces;
            }
        }else{
            newState[type][id] = _.omit(pieces, 'selected')
        }
        this.setState(newState)
    }
    onSubmit(data){
        let totalCaso = this.props.caso && this.props.caso.modelos && this.props.caso.modelos.length && this.props.caso.modelos.length/2;
        let totalUopload = this.props.files.order.length / 2;
        let total = totalCaso+totalUopload;

        let body = new FormData();
        if(this.props.files.files && this.props.files.files.length > 0){
            this.props.files.files.forEach(function(file){
                body.append('fileimgs[]', file);
            });
        }

        body.append('order', JSON.stringify(this.props.files.order));
        body.append('caso_id', JSON.stringify(this.props.casoId));

        let stepsTotal = [...Array(total).keys()];

        const state = this.state;

        let attachesObj = {};
        if(_.isArray(state.attachments)){
            state.attachments.forEach((item, index) => {
                attachesObj[index] = item;
            });
        } else {
            attachesObj = state.attachments;
        }
        let attachesArray = []
        _.forOwn(attachesObj, (value, key) => {
            let row = value.map( item => {
                let piece = {
                    step: key,
                    field: item.field,
                    type: item.type,
                    value: item.value
                };
                return piece;
            }); attachesArray = [...attachesArray,...row] });

        let irpArray = stepsTotal.map((item, i) => {
            let result;
            if(_.isArray(state.irp[i])) {
                if (state.irp[i]) {
                    result = _.keyBy(state.irp[i], 'field')
                    result = _.reduce(result, function (result, value, key) {
                        result[key] = value.value
                        return result;
                    }, {});

                } else {
                    result = []
                }
            }else{
                result = state.irp[i]
            }
            return result
        });
        let notes = _.map(_.toPairs(data), d => _.fromPairs([d]))
            .map((value) => {
                let noteKey = Object.keys(value)[0];
                let step = Number(noteKey.substring(noteKey.indexOf("_")).replace("_",""));
                return {
                    text: value[noteKey],
                    step
                };
            });

        body.append('steps', JSON.stringify({
                attachments: attachesArray,
                irp: irpArray,
                notes: notes
        }));

        this.props.onSubmit(body);
    }
    onPrev(){
        this.props.previousPage(this.props.files.files)
    }
    renderBoxes() {
        let boxes = [];
        let totalCaso = this.props.caso && this.props.caso.modelos && this.props.caso.modelos.length && this.props.caso.modelos.length/2;
        let totalUopload = this.props.files.order.length / 2;

        let total = totalCaso+totalUopload;

        for (let i = 0; i < total; i++) {
            let value = this.state.notes[`noteNum_${i}`];
            boxes.push(
                <div key={i} className="row step-admin-data">
                    <div className="col-md-12">
                        <h4>Movimiento {i}</h4>
                        <Field
                            name={`noteNum_${i}`}
                            type="text"
                            component={renderInput}
                            label="Nota"
                            col="col-md-12"
                            value={value}
                        />
                    </div>
                    <div className="col-md-6">
                        <h5>IPR</h5>
                        <OdontogramaIRP
                            id={i}
                            type="irp"
                            selectPiece={this.selectPiece.bind(this)}
                            pieces={{value: this.state.irp[i]}}
                            isEditable={true}
                        />
                    </div>
                    <div className="col-md-6">
                        <h5>Ataches</h5>
                        <div style={{marginTop:"10px"}}>
                            <Odontograma
                                id={i}
                                pieces={{value: this.state.attachments[i]}}
                                type="attachments"
                                selectPiece={this.selectPiece.bind(this)}
                                isEditable={true}
                            />
                        </div>
                    </div>
                </div>
            )
        }
        return boxes
    }
    render(){
        const { handleSubmit } = this.props;
        return(
            <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                {this.renderBoxes()}
                <div className="form-actions">
                    <button type="button" onClick={this.onPrev.bind(this)} className="btn btn-secondary next">
                        <i className="fa fa-chevron-left"></i>
                        &nbsp; Anterior
                    </button>
                    <button type="submit" className="btn btn-primary next float-right">
                        Enviar &nbsp;
                        <i className="fa fa-check-circle-o"></i>
                    </button>
                </div>
            </form>
        )
    }
}
const mapStateToProps = (state, ownProps) => {
    if(!ownProps.stepsGroup) return false;
    let initialValues = _.toArray(ownProps.stepsGroup[2])
        .map(item => {
            return {[`noteNum_${item.step}`]: item.value}
        });
    initialValues = _.reduce(initialValues, function(memo, current) { return _.assign(memo, current) },  {})
    return {
        initialValues
    };
};
ModelsStep2 = reduxForm({
    form: 'altamodelos',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    // validate,
})(ModelsStep2);



export default ModelsStep2 = connect(mapStateToProps, {
})(ModelsStep2);


// WEBPACK FOOTER //
// ./resources/assets/js/components/forms/models/ModelsStep2.jsx